(ns ui.cli.register
  "UI register of the cli slice: the Storrito CLI page under /ui/cli."
  (:require [ui.cli.page :as page]))

(def register
  [page/page])
